import React, { useState, useEffect } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Typography,
	Switch,
} from "@mui/material";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function CookiePreferencesModal() {
	const { consent, preferencesOpen, closePreferences, savePreferences } = useCookieConsent();
	const [analytics, setAnalytics] = useState(false);

	useEffect(() => {
		if (preferencesOpen) {
			setAnalytics(consent?.analytics ?? false);
		}
	}, [preferencesOpen, consent?.analytics]);

	const handleSave = () => {
		savePreferences(analytics);
	};

	return (
		<Dialog
			open={preferencesOpen}
			onClose={closePreferences}
			maxWidth="sm"
			fullWidth
			PaperProps={{
				sx: { borderRadius: 2 },
			}}
		>
			<DialogTitle sx={{ pb: 0 }}>Preferencias de cookies</DialogTitle>
			<DialogContent>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					Puedes activar o desactivar las cookies según tus preferencias. Las
					cookies técnicas son necesarias para el funcionamiento del sitio.
				</Typography>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<Box
						sx={{
							p: 2,
							bgcolor: "action.hover",
							borderRadius: 1,
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Box>
							<Typography variant="subtitle2">Técnicas</Typography>
							<Typography variant="caption" color="text.secondary">
								Necesarias para el funcionamiento (sesión, preferencias básicas).
								No se pueden desactivar.
							</Typography>
						</Box>
						<Switch checked disabled size="small" />
					</Box>
					<Box
						sx={{
							p: 2,
							bgcolor: "action.hover",
							borderRadius: 1,
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Box>
							<Typography variant="subtitle2">Analíticas</Typography>
							<Typography variant="caption" color="text.secondary">
								Nos ayudan a entender cómo se usa el sitio (p. ej. Google
								Analytics).
							</Typography>
						</Box>
						<Switch
							checked={analytics}
							onChange={(e) => setAnalytics(e.target.checked)}
							size="small"
						/>
					</Box>
				</Box>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={closePreferences}>Cancelar</Button>
				<Button variant="contained" onClick={handleSave}>
					Guardar preferencias
				</Button>
			</DialogActions>
		</Dialog>
	);
}
